import { encodeToken, PIN_FINGERPRINT_BYTE_LENGTH, TIMESLOT_EPOCH_UNIX } from '@pink/shared';

const DEMO_APPOINTMENT_ID = 0x42n;
const DEMO_LOCATION_ID = 7;
const DEMO_DAYS_AHEAD = 14;
const SECONDS_PER_DAY = 24 * 60 * 60;
const MS_PER_SECOND = 1000;

/**
 * Demo-Fingerprint: fixe 5 Bytes, da der Mock-Mode kein echtes Pinning fährt
 * (`<MockApp>` umgeht den Pinning-Layer komplett). Wert ist beliebig, solange
 * Layout-konform (Länge `PIN_FINGERPRINT_BYTE_LENGTH`).
 */
const DEMO_PIN_FINGERPRINT = new Uint8Array(PIN_FINGERPRINT_BYTE_LENGTH).fill(0xab);

/**
 * Erzeugt einen syntaktisch validen Demo-Token für den `VITE_MOCK_MODE`.
 *
 * Termin liegt 14 Tage in der Zukunft — deutlich über der 24-h-Cutoff-Grenze
 * und gut innerhalb des Plausibility-Fensters. Werte sind reine Demo-Werte;
 * nichts davon ist PHI.
 */
export function buildMockDemoToken(now: number = Date.now()): string {
  const nowSeconds = Math.floor(now / MS_PER_SECOND);
  const futureSeconds = nowSeconds + DEMO_DAYS_AHEAD * SECONDS_PER_DAY;
  const timeSlotSecondsFromEpoch = futureSeconds - TIMESLOT_EPOCH_UNIX;
  return encodeToken({
    appointmentId: DEMO_APPOINTMENT_ID,
    timeSlotSecondsFromEpoch,
    locationId: DEMO_LOCATION_ID,
    pinFingerprint: DEMO_PIN_FINGERPRINT,
  });
}
